// PathContext.js

import { createContext } from "react";

const PathContext = createContext(null);

export default PathContext;
